import TextField from '@mui/material/TextField'
import { DateTimePicker, DateTimePickerTabs } from '@mui/x-date-pickers'
import moment from 'moment-timezone'
import React from 'react'

import { noop } from '@/app/definitions'
import { formatDate } from '@/app/service/util'

import FormControl from './form-control'
import Input from './input'

const dateFormat = 'YYYY-MMM-DD HH:mm A'
const alwaysUseMobilePickerMediaQuery = '@media (min-width: 99999px)'

const getDateValue = (value: string, timezone?: string) => {
  const dateValue = timezone ? moment.tz(value, timezone) : moment(value)
  return !dateValue.isValid() ? undefined : dateValue
}

type DateTimeFieldProps = {
  disablePast?: boolean
  editable?: boolean
  error?: string
  info?: string
  label?: string
  name: string
  timezone?: string
  useMobilePicker?: boolean
  value?: string
  onChange: (p: { name: string; value: moment.Moment | null }) => void
  onClose?: () => void
  onOpen?: () => void
}

export default function DateTimeField({
  disablePast = true,
  editable = true,
  error = '',
  info = '',
  label,
  name,
  timezone,
  useMobilePicker = true,
  value = new Date().toString(),
  onChange,
  onClose = noop,
  onOpen = noop,
}: DateTimeFieldProps) {
  const ref = React.useRef(null)
  const [open, setOpen] = React.useState(false)
  const dateValue = getDateValue(value, timezone)
  if (!editable) {
    return (
      <Input
        type="text"
        name={name}
        label={label}
        editable={false}
        value={formatDate(value, timezone)}
        onChange={() => {}}
      />
    )
  }

  return (
    <FormControl error={error} info={info}>
      <div ref={ref}>
        <DateTimePicker
          disablePast={disablePast}
          desktopModeMediaQuery={useMobilePicker ? alwaysUseMobilePickerMediaQuery : undefined}
          format={dateFormat}
          label={label}
          open={open}
          value={dateValue}
          slots={{
            tabs: (props) => <DateTimePickerTabs {...props} />,
            textField: (props) => (
              <TextField
                {...props}
                name={name}
                InputProps={{
                  ...props.InputProps,
                  endAdornment: null,
                  name,
                }}
                style={{ width: '100%' }}
                variant="standard"
                onChange={noop}
                onClick={() => setOpen(true)}
              />
            ),
          }}
          slotProps={{
            popper: {
              anchorEl: ref.current,
            },
            tabs: {
              hidden: false,
            },
          }}
          onChange={(e) => {
            onChange({
              name,
              value: e,
            })
          }}
          onClose={() => {
            setOpen(false)
            onClose?.()
          }}
          onOpen={onOpen}
        />
      </div>
    </FormControl>
  )
}
